module.exports = __webpack_public_path__ + "img/2025-08-16c_5.3480aece.jpg";